import { useState } from 'react';

interface NewsletterProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  backgroundColor?: string;
}

export function NewsletterBlock({ props }: { props: NewsletterProps }) {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  return (
    <section
      className="py-12 px-4 rounded-lg"
      style={{ backgroundColor: props.backgroundColor || '#f4f4f5' }}
    >
      <div className="max-w-lg mx-auto text-center">
        <h2 className="text-xl font-bold text-zinc-900 mb-2">{props.title ?? 'Stay Updated'}</h2>
        {props.subtitle && <p className="text-sm text-zinc-600 mb-6">{props.subtitle}</p>}
        {submitted ? (
          <p className="text-emerald-600 font-medium">Thanks for subscribing!</p>
        ) : (
          <form
            onSubmit={(e) => { e.preventDefault(); setSubmitted(true); }}
            className="flex gap-2 max-w-sm mx-auto"
          >
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 px-3 py-2 rounded-lg border border-zinc-300 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <button type="submit" className="px-4 py-2 rounded-lg bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 transition-colors">
              {props.buttonText ?? 'Subscribe'}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
